import React from 'react'
import { Box } from '@mui/material'
import { motion } from 'framer-motion'
import { INTERAX_COLORS } from '../../../constants/colors'
import { GlintReveal } from './GlintReveal'
import type { GlintRevealCoverLayers } from '../hooks/useGlintRevealCover'

const MotionBox = motion(Box)

/** The frosted cover over a feedback box and the glint that plays as it fades; sits inside a relative box. */
export const GlintRevealLayers: React.FC<GlintRevealCoverLayers> = ({
  isCovered,
  isOverlayActive,
  overlayState,
  glintPhase,
  glintTrigger,
  glintDurationSec,
  fadeDurationSec,
  onGlintComplete
}) => (
  <>
    {isOverlayActive ? (
      <MotionBox
        sx={{
          position: 'absolute',
          inset: 0,
          borderRadius: 'inherit',
          pointerEvents: 'none',
          background: `linear-gradient(148deg, ${INTERAX_COLORS.heritageBlue40} 0%, ${INTERAX_COLORS.white08} 100%)`,
          border: `1px solid ${INTERAX_COLORS.white04}`,
          boxShadow: 'inset 0 1px 0 rgba(255, 255, 255, 0.12)',
          backdropFilter: 'blur(12px)',
          zIndex: 1
        }}
        initial={{ opacity: 1 }}
        animate={{ opacity: overlayState === 'fade' ? 0 : 1 }}
        transition={{
          duration: overlayState === 'fade' ? Math.max(fadeDurationSec, 0.01) : 0.1,
          ease: 'easeInOut'
        }}
      />
    ) : null}

    {isCovered ? (
      <Box sx={{ position: 'absolute', inset: 0, borderRadius: 'inherit', pointerEvents: 'none', zIndex: 2 }}>
        <GlintReveal
          active={glintPhase === 'running'}
          trigger={glintTrigger}
          glintDuration={glintDurationSec}
          onComplete={onGlintComplete}
        />
      </Box>
    ) : null}
  </>
)
